import axios from "axios";
import API from "../helpers/api";
import FileSaver from "file-saver";
import { toast } from "react-toastify";

let userrole = localStorage.getItem("UserRoles");
let user = JSON.parse(localStorage.getItem("currentUser"));

export const getShipsCount = (shipId,contract,both) => {
  let url = "";
  if (userrole === "staff") {
    url = `${API.ShipEquipmentCount + shipId}&mail=${user.email}&inContract=${contract}&isBoth=${both}`;
  } else {
    url = `${API.ShipEquipmentCount + shipId}&inContract=${contract}&isBoth=${both}`;
  }
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetShipEquipmentCountSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetShipEquipmentCountFailure",
          error: "ERROR",
        });
      });
  };
};

export const getShipDeatil = (shipId) => {
  // shipId = 2;
  /* &status=${status} */
  let url = `${API.ShipDetail}?shipId=${shipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetShipDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetShipDetailFailure",
          error: "ERROR",
        });
      });
  };
};

export const getShipEquipmentSearchlist = (searchItem,contract,both) => {
  let url = `${API.SearchShipEquipment}?FliterByTotalShips=${
    searchItem.isTotalShips ?? true
  }&FliterByOverDue=${searchItem.isOverdueShips ?? false}&FliterByDueIn10Days=${
    searchItem.isShipsDue10 ?? false
  }&FliterByDueIn30Days=${
    searchItem.isShipsDue30 ?? false
  }&FliterByDueIn60Days=${
    searchItem.isShipsDue60 ?? false
  }&FliterByDueIn90Days=${searchItem.isShipsDue90 ?? false}&Equipment=${
    searchItem.equipment ?? ""
  }&Category=${searchItem.category ?? ""}&shipId=${
    searchItem.shipId ?? 0
  }&ServiceTypes=${searchItem.ServiceTypes ?? []}&NextDueInFromDate=${
    searchItem.next_due_in_from ?? ""
  }&Status=${searchItem.status}&NextDueInToDate=${searchItem.next_due_in_to ?? ""}&PageNumber=${
    searchItem.pagenumber ?? 1
  }&PageSize=${searchItem.pagesize ?? 25}&inContract=${contract}&isBoth=${both}&isShipService=${searchItem?.isShipService != undefined ? searchItem?.isShipService : false}&isShoreService=${searchItem?.isShoreService != undefined ? searchItem?.isShoreService : false}`;
  return (dispatch) => {
    dispatch({
      type: "MDSearchIsTrue",
      data: searchItem,
    });
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetShipSearchSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetShipSearchFailure",
          error: "ERROR",
        });
      });
  };
};

export const getEquipmentInfo = (shipEquipmentId) => {
  let url = `${API.GetEquipmentInfo}?shipEquipmentId=${shipEquipmentId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetEquipmentInfoSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetEquipmentInfoFailure",
          error: "ERROR",
        });
      });
  };
};

export const getEquipmentDetails = (shipId) => {
  let url = `${API.GetEquipmentDetails + shipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetEquipmentDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetEquipmentDetailFailure",
          error: "ERROR",
        });
      });
  };
};

export const getEquipmentHistory = (shipId) => {
  let url = `${API.GetEquipmentHistory}?shipEquipmentId=${shipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetEquipmentHistorySuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetEquipmentHistoryFailure",
          error: "ERROR",
        });
      });
  };
};

export const getMDSearchlist = (searchItem) => {
  let url = `${API.MDSearch}?minyear=${searchItem.minyear}&mdidno=${searchItem.mdidno}&maxyear=${searchItem.maxyear}&supplier=${searchItem.supplier}&SDocIdNo=${searchItem.sdocid}&productname=${searchItem.productname}&productnumber=${searchItem.productnumber}&sortorder=${searchItem.sortorder}&sortby=${searchItem.sortby}&pagesize=${searchItem.pagesize}&pagenumber=${searchItem.pagenumber}`;
  return (dispatch) => {
    dispatch({
      type: "MDSearchIsTrue",
      data: searchItem,
    });
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMDSearchSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetMDSearchFailure",
          error: "ERROR",
        });
      });
  };
};

export const downloadStatus = (shipId) => {
  let url = `${API.poStatusExport}?shipId=${shipId}`;
  return (dispatch) => {
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";

        console("name", response.data);
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob);
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "AttchmentUploadedFailure",
          error: "ERROR",
        });
      });
  };
};

export const downloadShipEquipmentStatus = (shipId, shipName,contract,both) => {
  let url = `${API.downloadEquipmentStatus}?shipId=${shipId}&inContract=${contract}&isBoth=${both}`;
  return (dispatch) => {
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";

        blob = new Blob([response.data], { type: response.data.type });
        var mime = require('mime-types'),
        fileExtension = mime.extension(response.data.type)
        FileSaver.saveAs(blob, shipName+"."+fileExtension);
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "AttchmentUploadedFailure",
          error: "ERROR",
        });
      });
  };
};

export const downloadServiceRequest = (item, data,contract,both) => {
  let url = `${API.getServiceRequest}?shipId=${item.shipId}&isShore=${data.isShore}&isShip=${data.isShip}&isBoth=${data.isBoth}&inContract=${contract}&isAll=${both}`;
  return (dispatch) => {
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";

        blob = new Blob([response.data], { type: response.data.type });
        var mime = require('mime-types'),
        fileExtension = mime.extension(response.data.type)
        FileSaver.saveAs(blob, item.shipName+"."+fileExtension);
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "AttchmentUploadedFailure",
          error: "ERROR",
        });
      });
  };
};

export const deleteEquipmentHistory = (shipId, serviceId) => {
  let url = `${API.GetEquipmentHistory}?ServicehistoryId=${serviceId}`;
  return (dispatch) => {
    axios
      .delete(url)
      .then((response) => {
        if (response.data === true) {
          dispatch(getEquipmentHistory(shipId));
          toast.success("Service history deleted Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error("Failed to delete service history", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to delete service history", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };
};

export const getEquipmentServiceHistoryCost = (contractId) => {
  let url = `${API.ServiceCost}?contractId=${contractId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetShipEquipmentServiceBudgetSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetShipEquipmentServiceBudgetFailure",
          error: "ERROR",
        });
      });
  };
}

export const getEquipmentReportOptions = (shipId) => {
  let url = `${API.ContractUsersOptions}?shipId=${shipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetShipUsersOptionSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        // dispatch({
        //   type: "GetShipEquipmentServiceBudgetFailure",
        //   error: "ERROR",
        // });
      });
  };
}

export const getEquipmentServiceOverAllBudget = (contractId) => {
  let url = `${API.ServiceBudget}?contractId=${contractId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetShipEquipmentBudgetSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetShipEquipmentBudgetFailure",
          error: "ERROR",
        });
      });
  };
}